import { ChangePasswordComponent } from './change-password.component';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppMaterialModule } from '../app-material/app-material.module';
import { InputErrorPipe } from './models/input-error.pipe';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from '../shared.module';
import { PasswordGenerationComponent } from './password-generation/password-generation.component';

export function createTranslateLoader(http: HttpClient) {
  var timestamp = new Date().getTime();
  return new TranslateHttpLoader(http, './assets/i18n/', `.json?t=${timestamp}`);
}

@NgModule({
  declarations: [ChangePasswordComponent,PasswordGenerationComponent, InputErrorPipe],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppMaterialModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    })
  ],
  exports : [ChangePasswordComponent,PasswordGenerationComponent]
})
export class ChangePasswordModule { }
